import gql from 'graphql-tag';
import { baseResponseGraphql } from "@/graphql/base.graphql.js";


export const uploadFileFields = `
fullFileName
fileName
`

export const uploadBase64File = gql`
mutation UploadBase64File($input: Base64FileInputObjects!) {
  uploadBase64File(input: $input) {
    ${baseResponseGraphql}
    data {
      ${uploadFileFields}
    }
  }
}
`

